import { createSelector } from 'reselect';
import { compare } from './../utility/CompareUtils';

const Audit = 'audit';

const selectAllAudits = (state) => state.get(Audit).get('allAudits');
const getAllAudits = createSelector(selectAllAudits, (data) => {
  const sortedList = data.sort((a, b) => compare(b.get('timestamp'), a.get('timestamp')));
  return sortedList;
});

const selectUserAudits = (state) => state.get(Audit).get('userAudits');
const getAllUserAudits = createSelector(selectUserAudits, (data) => {
  const sortedList = data.sort((a, b) => compare(b.get('timestamp'), a.get('timestamp')));
  return sortedList;
});

const selectAuditTypes = (state) => state.get(Audit).get('auditTypes');
const getAuditTypes = createSelector(selectAuditTypes, (data) => {
  const sortedList = data.sort((a, b) => compare(a, b));
  return sortedList;
});

const selectIsLoading = (state) => state.get(Audit).get('isLoading');
const getLoadingStatus = createSelector(selectIsLoading, (data) => data);

export { getAllAudits, getAllUserAudits, getLoadingStatus, getAuditTypes };
